// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const baseUrl = process.env.REACT_APP_API_URL;
import LocalStorage from 'utilities/localStorage';
// Define a service using a base URL and expected endpoints
export const logBooksApi = createApi({
  reducerPath: 'logBooksApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const user = LocalStorage.getItem('Gravity_user');
      const authToken = user?.token;
      const sessionToken = user?.session_token;
      if (authToken) {
        headers.set('authorization', `Bearer ${authToken}`);
      }
      if (sessionToken) {
        headers.set('x-session-token', sessionToken);
      }

      return headers;
    }
  }),
  tagTypes: [
    'trhmrLogBooks',
    'UacrOfSamplingOrDbars',
    'vacuumCleaningLogBooks',
    'waterCollectionLogBooks',
    'dispensingAidsLogBooks',
    'STPLogBooks'
  ],

  endpoints: (builder) => ({
    // Fetching all TRHMR records &
    // #region Fetching all TRHMR recods of Given areaName, equipmentId and date
    getTrhmrList: builder.query({
      query: (name) => {
        return {
          url: 'trhmr-log-book-list/',
          params: name
        };
      },
      providesTags: ['trhmrLogBooks']
    }),
    // #endregion

    // #region Fetching all recods from Temperature area name master
    getTemperatureAreaMasters: builder.query({
      query: (name) => {
        return {
          url: 'area-name-list',
          params: name
        };
      }
    }),
    // #endregion

    // #region Fetching all recods from Thermo hygrometer id masters
    getHygrometerIdMasters: builder.query({
      query: (name) => {
        return {
          url: 'thermo-hygrometer-id-list',
          params: name
        };
      }
    }),
    // #endregion

    // #region Checking if the TRHMR record exists for given areaName, quipmentId, date and time to avoid creating duplicates
    getAlreadyExistingTrhmrLogBooks: builder.query({
      query: (name) => {
        if (name.thermoHygrometerIdMasterId && name.areaNameMasterId) {
          return {
            url: 'trhmr-time-verification',
            params: name
          };
        }
      }
    }),
    // #endregion

    // #region Initiating verification for creating of all log books
    initiateVerification: builder.mutation({
      query: (name) => ({
        url: 'initiate-verification',
        method: 'POST',
        body: name
      })
    }),
    // #endregion

    // #region Creating Temperature and relative humidity monitoring record
    createTrhmrLogBook: builder.mutation({
      query: (name) => ({
        url: 'trhmr-log-book',
        method: 'POST',
        body: name
      }),
      invalidatesTags: ['trhmrLogBooks']
    }),
    // #endregion

    // #region Fetching all recods from Usage and Cleaning record of Sampling / Dispensing Booth and Room area name master
    getUacrOfSamplingOrDbarAreaMasters: builder.query({
      query: (name) => {
        return {
          url: 'usage-cleaning-area-lists',
          params: name
        };
      }
    }),
    // #endregion

    // #region Fetching all recods from Usage and Cleaning record of Sampling / Dispensing Booth and Room Cleaning Accessories master
    getUacrOfSamplingOrDbarCleaningAccessoriesMasters: builder.query({
      query: (name) => {
        return {
          // url needs to change
          url: 'cleaning-accessories-list',
          params: name
        };
      }
    }),
    // #endregion

    // #region Fetching available batches by area for UACR
    getUacrAvailableBatches: builder.query({
      query: (params) => ({
        url: 'usage-cleaning-available-batches',
        params
      })
    }),
    // #endregion

    // #region Fetching all recods from Usage and Cleaning record of Sampling / Dispensing Booth and Rooms
    getUacrOfSamplingOrDbars: builder.query({
      query: (name) => {
        return {
          url: 'usage-cleaning-log-book-list',
          params: name
        };
      },
      providesTags: ['UacrOfSamplingOrDbars']
    }),
    // #endregion

    // #region Fetching all recods from Usage and Cleaning record of Sampling / Dispensing Booth and Rooms
    createUacrOfSamplingOrDbar: builder.mutation({
      query: (name) => ({
        url: 'usage-cleaning-log-book',
        method: 'POST',
        body: name
      }),
      invalidatesTags: ['UacrOfSamplingOrDbars']
    }),
    // #endregion

    // #region Saving a partial (unverified) draft of a UACR record
    saveUacrDraft: builder.mutation({
      query: (name) => ({
        url: 'usage-cleaning-log-book/draft',
        method: 'POST',
        body: name
      }),
      invalidatesTags: ['UacrOfSamplingOrDbars']
    }),
    // #endregion

    // #region LC Area Name other information
    getLafProductOrMaterialNameAndOtherInformation: builder.query({
      query: (name) => {
        if (name.area_name) {
          return {
            url: 'lc/area_name',
            params: name
          };
        }
      }
    }),
    // #endregion
    // #region Get Vacuum Cleaning List
    getVacuumCleaningList: builder.query({
      query: (name) => {
        return {
          url: 'vacuum-cleaning-record-log-book-list-view',
          params: name
        };
      },
      providesTags: ['vacuumCleaningLogBooks']
    }),
    // #endregion

    // #region Create Vacuum Cleaning record
    createVaccumCleaning: builder.mutation({
      query: (name) => ({
        url: 'vacuum-cleaning-record-log-book',
        method: 'POST',
        body: name
      }),
      invalidatesTags: ['vacuumCleaningLogBooks']
    }),
    // #endregion

    // #region Fetching Vacuum Cleaning Location Masters
    getVaccumCleaningLocationMasters: builder.query({
      query: (name) => {
        return {
          url: 'vacuum-cleaning-location-masters',
          params: name
        };
      }
    }),
    // #endregion
    // #region Fetching Vacuum Cleaning Location Masters
    getVaccumCleaningIdMasters: builder.query({
      query: (name) => {
        return {
          url: 'vacuum-cleaning-id-masters',
          params: name
        };
      }
    }),
    // #endregion
    // #region Get Vacuum Cleaning List
    getWaterCollectionList: builder.query({
      query: (name) => {
        return {
          url: '/purified-water-collection-log-book-list-view',
          params: name
        };
      },
      providesTags: ['waterCollectionLogBooks']
    }),
    // #endregion

    // #region Create Vacuum Cleaning record
    createWaterCollection: builder.mutation({
      query: (name) => ({
        url: 'purified-water-collection-log-book',
        method: 'POST',
        body: name
      }),
      invalidatesTags: ['waterCollectionLogBooks']
    }),
    // #endregion
    // #region Get Dispensing aids List
    getDispensingAidsList: builder.query({
      query: (name) => {
        return {
          url: '/dispensing-aids-log-book-list',
          params: name
        };
      },
      providesTags: ['dispensingAidsLogBooks']
    }),
    // #endregion
    // #region Get Dispensing equipment List
    getDispensingAidsEquipmentMasters: builder.query({
      query: (name) => {
        return {
          url: '/dispensing-aids-equipment-masters',
          params: name
        };
      }
    }),
    // #endregion
    // #region Get Dispensing aids ID masters
    getDispensingAidsIdMasters: builder.query({
      query: (name) => {
        return {
          url: '/dispensing-aids-id-masters',
          params: name
        };
      }
    }),
    // #endregion
    // #region Create Dispensing Aids record
    createDispensingAids: builder.mutation({
      query: (name) => ({
        url: 'dispensing-aids-log-book',
        method: 'POST',
        body: name
      }),
      invalidatesTags: ['dispensingAidsLogBooks']
    }),
    // #endregion
    // #region Get Solvent Transfer Pump cleaning List
    getSTPCleaningList: builder.query({
      query: (name) => {
        return {
          url: '/solvent-transfer-pump-cleaning-log-book-list',
          params: name
        };
      },
      providesTags: ['STPLogBooks']
    }),
    // #endregion
    // #region Get Dispensing aids ID masters
    getSTPIdMasters: builder.query({
      query: (name) => {
        return {
          url: '/solvent-transfer-pump-equipment-id-masters',
          params: name
        };
      }
    }),
    // #endregion
    // #region Get STP Product / Batch number masters
    getSTPProductBatchNoMasters: builder.query({
      query: (name) => {
        return {
          url: '/inhouse-batch-or-product-batch-number',
          params: name
        };
      }
    }),
    // #endregion
    // #region Create STP record
    createSolventTransferPump: builder.mutation({
      query: (name) => ({
        url: 'solvent-transfer-pump-cleaning-log-book',
        method: 'POST',
        body: name
      }),
      invalidatesTags: ['STPLogBooks']
    })
    // #endregion
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTrhmrListQuery,
  useGetTemperatureAreaMastersQuery,
  useGetHygrometerIdMastersQuery,
  useGetAlreadyExistingTrhmrLogBooksQuery,
  useLazyGetAlreadyExistingTrhmrLogBooksQuery,
  useInitiateVerificationMutation,
  useCreateTrhmrLogBookMutation,
  useGetUacrOfSamplingOrDbarAreaMastersQuery,
  useGetUacrOfSamplingOrDbarCleaningAccessoriesMastersQuery,
  useGetUacrOfSamplingOrDbarsQuery,
  useLazyGetUacrAvailableBatchesQuery,
  useCreateUacrOfSamplingOrDbarMutation,
  useSaveUacrDraftMutation,
  useLazyGetLafProductOrMaterialNameAndOtherInformationQuery,
  useGetVacuumCleaningListQuery,
  useCreateVaccumCleaningMutation,
  useGetVaccumCleaningLocationMastersQuery,
  useGetVaccumCleaningIdMastersQuery,
  useGetWaterCollectionListQuery,
  useCreateWaterCollectionMutation,
  useGetDispensingAidsListQuery,
  useGetDispensingAidsEquipmentMastersQuery,
  useGetDispensingAidsIdMastersQuery,
  useCreateDispensingAidsMutation,
  useGetSTPCleaningListQuery,
  useGetSTPIdMastersQuery,
  useGetSTPProductBatchNoMastersQuery,
  useCreateSolventTransferPumpMutation
} = logBooksApi;
